import * as yup from "yup";
import { constant } from "common/constant"; // Adjust path if needed

export const PanelSchema = yup.object({
    panelName: yup
        .string()
        // .trim()
        .required(constant.requiredPanelName || "Panel name is required"),

    skills: yup
        .array()
        .of(yup.string().required())
        .min(1, constant.requiredSkills || "At least one skill is required")
        .required(constant.requiredSkills || "Skills are required")
        .test(
            "check-custom-other",
            function (value) {
                const { customSkill } = this.parent;
                // If no "Other" selected, no need to validate customSkill
                if (!value?.includes("Other")) {
                    return true;
                }
                // 1️⃣ Check if customSkill is entered
                if (!customSkill || customSkill.trim() === "") {
                    return this.createError({
                        message: "Please enter a custom skill",
                    });
                }
                // 2️⃣ Check if customSkill already exists in skills list
                const exists = value.some(
                    (skill) =>
                        skill.trim().toLowerCase() === customSkill.trim().toLowerCase()
                );
                if (exists) {
                    return this.createError({
                        message: "Custom skill already exists in skills list",
                    });
                }
                return true; // All good
            }
        )
    ,
    customSkill: yup.string(),
    totalExperienceRange: yup
        .string()
        // .oneOf(['0-1', '1-3', '3-5', '5-10', '10+'], "Invalid experience range")
        .required(constant.requiredExperience || "Experience range is required"),

    interviewAvailability: yup
        .array()
        .of(yup.string())
        .min(1, constant.requiredAvailability || "Availability is required")
        .required(constant.requiredAvailability || "Interview availability is required"),

    //   tenantId: yup
    //     .string()
    //     .required(constant.requiredTenantId || "Tenant ID is required"),

    //   createBy: yup
    //     .string()
    //     .nullable(), // Optional field

    //   deleted: yup
    //     .boolean()
    //     .nullable(), // Default false in backend; nullable here for flexibility
});
